(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('teJHipsterApp')
        .constant('VERSION', "1.1.0-release198")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
